export default "__VITE_ASSET__Se_dwm1E__"